import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import VStack from "shared/components/layout/stack/VStack";
import ModalActions from "shared/components/feedback/modals/ModalActions";
import TextArea from "shared/components/inputs/form-fields/TextArea";
import Form from "shared/components/inputs/form/Form";
import { sendNotification } from "shared/components/feedback/notification/notification";
import useManageUserTimeOff from "features/timesheet/manage-time-off/useManageUserTimeOff";
import ManageTimeOffContext from "features/timesheet/contexts/ManageTimeOffContext";

const StyledTextArea = styled(TextArea)`
    textarea {
        min-height: 116px;
    }
`;

const RejectTimeOffForm = ({ timeOffRequestId, onClose }) => {
    const { rejectTimeOff } = useManageUserTimeOff();
    const { rejectActionFromMenu, manageTimeOffRequestsData } =
        useContext(ManageTimeOffContext);
    const currentManageUserData = manageTimeOffRequestsData?.find(
        (data) => data.id === timeOffRequestId
    );
    const isEditing = timeOffRequestId !== undefined;
    const modifier = rejectTimeOff;

    if (isEditing && !currentManageUserData) {
        return <div>Could not find holiday</div>;
    }

    const onSubmit = async (formData) => {
        const allData = {
            timeOffRequestId: timeOffRequestId,
            body: formData.note,
        };

        await modifier.mutateAsync(allData);
        onClose();
        sendNotification(
            <>
                Time off request for{" "}
                {currentManageUserData?.employeeFullName} has been rejected
            </>
        );
    };
    return (
        <Form onSubmit={onSubmit}>
                <VStack spacing="Two">
                    <StyledTextArea
                        validations={{
                            required: true
                        }}
                        name="note"
                        showClearIcon={true}
                        label="Reason for Decision"
                        description="Required"
                        placeholder="Please provide further explanation"
                    />
                    <ModalActions
                        primaryAction={{
                            type: "submit",
                            label: "Reject",
                            leadingIcon: "error",
                        }}
                        secondaryAction={{
                            type: "button",
                            label: rejectActionFromMenu ? "Cancel" : "Back",
                            to:
                                !rejectActionFromMenu &&
                                `?action=viewRequest&id=${timeOffRequestId}`,
                            onClick: rejectActionFromMenu && onClose,
                        }}
                    />
                </VStack>
        </Form>
    );
};

RejectTimeOffForm.propTypes = {
    timeOffRequestId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired
};

export default RejectTimeOffForm;
